<template>
    <div class="chart-container">
        <div class="primary-content">
            <div class="values">
                <div class="lga-value lg">
                    {{ model.format(model.value) }}<span class="lga-units">{{ model.valueUnits }}</span>
                </div>
                <div class="label">
                    {{ model.label }}
                </div>
                <div class="compare-value">
                    {{ model.formatWithUnits(model.comparisonValue) }} in {{ model.comparisonLabel }}
                </div>
            </div>
            <dynamic-resize-container
                class="waffle-chart"
            >
                <template
                    #default="{width}"
                >
                    <waffle-chart
                        v-if="width > 0"
                        :value="model.value"
                        :compare-value="model.comparisonValue"
                        :size="width"
                    >
                        <template
                            #tooltip-content="{ value, type }"
                        >
                            <div
                                :class="`${type === 'compare' ? 'tooltip-compare' : ''}`"
                            >
                                <div class="tooltip-label">
                                    {{ type === 'value' ? model.valueLabel : model.comparisonLabel }}
                                </div>
                                <div class="tooltip-value">
                                    {{ model.formatWithUnits(value) }}
                                </div>
                            </div>
                        </template>
                    </waffle-chart>
                </template>
            </dynamic-resize-container>
        </div>

        <info-tooltip
            :definition="model.definition"
            :link-to-health="model.linkToHealth"
            :data-source="model.dataSource"
        />
    </div>
</template>

<script>
import DynamicResizeContainer from '@/components/DynamicResizeContainer.vue';
import WaffleChart from '@/components/WaffleChart.vue';
import InfoTooltip from '@/components/InfoTooltip.vue';

import MetricChartModel from '@/model/MetricChartModel';

export default {
    components: {
        DynamicResizeContainer, WaffleChart, InfoTooltip
    },
    props: {
        model: {
            type: MetricChartModel,
            required: true
        }
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>
.primary-content {
    @apply flex flex-row justify-around
}

.values {
    @apply flex flex-col flex-grow;
    width: 60%;
}

.waffle-chart {
    @apply flex-grow flex-shrink ml-2;
    min-width: 100px;
    width: 40%;
}

.compare-value {
    @apply mt-auto;
}


.tooltip-compare {
    @apply text-neutral-text;
}

.tooltip-value {
    @apply text-xl font-bold leading-tight;
}
.tooltip-label {
    @apply text-xs leading-tight;
}
</style>
